import React from 'react';

const exStockImg = 'https://storage.googleapis.com/imgez/exstock/exstock-tag-rectangle.svg'

class ExStockImg extends React.Component {

  render() {

    const width = this.props.width ? this.props.width : '70px'

    return (
      <div style={{ width: width, height: 'auto' }}>
        <img alt="ex stock logo" src={exStockImg} style={{maxWidth: '100%', maxHeight: '100%', display: 'block'}} />
      </div>
    )

  }
}

export default ExStockImg;


// WEBPACK FOOTER //
// ./src/components/product-ex-stock/tag.js